/* eslint-disable no-unused-expressions */
import { Autocomplete, MultiSelect, Select } from '@mantine/core';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { DatePicker, MonthPicker } from '@mantine/dates';
import { useNavigate } from 'react-router-dom';
import { objectToQueryString, queryStringToObject } from '@/helpers/string';
import routes from '@/routes';
import { routeWithParams } from '@/helpers/route';

const ColumnFilter = (obj) => {
  const {
    filters,
    setFilters,
    accessor,
    options = [],
    label = '',
    type = 'autoComplete',
    isUrlChange = false,
    rawUrlQuery,
    reportId,
  } = obj;

  const [opened, setOpened] = useState(false);
  const navigate = useNavigate();

  const globalProps = {
    label,
    value: filters[accessor],
    clearable: true,
    searchable: true,
    data: options,
    onChange: (value) => {
      isUrlChange ? updateUrl(value) : setFilters((prev) => ({ ...prev, [accessor]: value }));
      setOpened(value && value.length > 0);
    },
  };

  const inputComponents = {
    autoComplete: {
      componentName: Autocomplete,
      componentProps: {
        dropdownOpened: opened,
        onClear: () => {
          isUrlChange ? updateUrl('') : setFilters((prev) => ({ ...prev, [accessor]: '' }));
        },
        onBlur: () => setOpened(false),
      },
    },
    multiSelect: {
      componentName: MultiSelect,
      componentProps: {
        onClear: () => {
          isUrlChange ? updateUrl([]) : setFilters((prev) => ({ ...prev, [accessor]: [] }));
        },
      },
    },
    monthPicker: {
      componentName: MonthPicker,
      componentProps: {
        value: filters.year && filters.month && new Date(filters.year[0], filters.month[0] - 1),
        onChange: (value) => {
          isUrlChange
            ? updateUrl(value)
            : setFilters((prev) => ({
              ...prev,
              month: [value.getMonth() + 1],
              year: [value.getFullYear()],
            }));
        },
      },
    },
    datePicker: {
      componentName: DatePicker,
      componentProps: {
        clearable: true,
        locale: 'he',
        valueFormat: 'DD/MM/YYYY',
        type: 'range',
        value: filters[accessor] || [null, null],
        onChange: (value) => {
          isUrlChange
            ? updateUrl(value)
            : setFilters((prev) => ({ ...prev, [accessor]: value }));
        },
      },
    },
    select: {
      componentName: Select,
    },
  };

  const updateUrl = (value) => {
    const parsedQuery = queryStringToObject(rawUrlQuery);
    const companyOption = options.find((opt) => opt.value === value);
    const agents = options.find((opt) => opt.value === value);

    switch (accessor) {
      case 'date':
        parsedQuery.month = value ? [value.getMonth() + 1] : [];
        parsedQuery.year = value ? [value.getFullYear()] : [];
        break;
      case 'fullName':
        parsedQuery.agent = agents ? [agents.value] : [];
        break;
      case 'company':
        parsedQuery.company = companyOption ? [companyOption.value] : [];
        break;
      default:
        parsedQuery[accessor] = value;
        break;
    }

    const { path } = routes.reportsView;
    const queryParams = objectToQueryString(parsedQuery);
    const fullPath = routeWithParams(path, { id: reportId, query: queryParams });
    navigate(fullPath);
  };

  const component = inputComponents[type];
  const ComponentName = component.componentName;
  return <ComponentName {...globalProps} {...component.componentProps} />;
};

ColumnFilter.propTypes = {
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  accessor: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  type: PropTypes.string,
  isUrlChange: PropTypes.bool,
  rawUrlQuery: PropTypes.string,
  reportId: PropTypes.string,
};

export default ColumnFilter;
